 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a4c92b5b","1":"commons","2":"styles","3":"11100001","4":"3c486bea7d67ad134ab8663d49ccbdc87e5e568a","5":"05b744bfcadbf0a07222ad13dac81db548c3f685","6":"038c46d8fd00ce50b1c747f9b607d00b7f9227fc","7":"c4feed739e63bbbd9e7020453f96b9f103dad3d2","11":"component---src-pages-404-js","12":"component---src-pages-about-js","13":"component---src-pages-contact-js","14":"component---src-pages-explore-js","15":"component---src-pages-index-js","16":"component---src-pages-news-js","17":"component---src-pages-privacy-policy-js","18":"component---src-pages-returns-and-refunds-policy-js","19":"component---src-pages-shipping-policy-js","20":"component---src-pages-shop-airport-band-sweatshirt-js","21":"component---src-pages-shop-alice-dress-js","22":"component---src-pages-shop-alva-windbreaker-js","23":"component---src-pages-shop-bag-js","24":"component---src-pages-shop-baggage-tag-jumpsuit-js","25":"component---src-pages-shop-baggage-tag-keyring-js","26":"component---src-pages-shop-baggage-tag-sweatshirt-1-js","27":"component---src-pages-shop-baggage-tag-sweatshirt-js","28":"component---src-pages-shop-baggage-tag-t-shirt-1-js","29":"component---src-pages-shop-baggage-tag-t-shirt-js","30":"component---src-pages-shop-bedford-hoodie-js","31":"component---src-pages-shop-bedford-sweatpant-js","32":"component---src-pages-shop-blanket-js","33":"component---src-pages-shop-bowery-pant-js","34":"component---src-pages-shop-bustier-dress-js","35":"component---src-pages-shop-carmine-leggings-js","36":"component---src-pages-shop-carmine-short-js","37":"component---src-pages-shop-carmine-top-js","38":"component---src-pages-shop-cart-js","39":"component---src-pages-shop-clinton-windbreaker-js","40":"component---src-pages-shop-cornelia-pant-js","41":"component---src-pages-shop-cornelia-top-js","42":"component---src-pages-shop-index-js","43":"component---src-pages-shop-lawton-sweatpant-js","44":"component---src-pages-shop-lott-dress-js","45":"component---src-pages-shop-oblo-dress-js","46":"component---src-pages-shop-poncho-js","47":"component---src-pages-shop-qr-code-sweatshirt-js","48":"component---src-pages-shop-rainbow-sweatshirt-js","49":"component---src-pages-shop-recycled-cashmere-sweatshirt-1-js","50":"component---src-pages-shop-recycled-cashmere-sweatshirt-js","51":"component---src-pages-shop-skirt-js","52":"component---src-pages-shop-sullivan-dress-js","53":"component---src-pages-shop-top-js","54":"component---src-pages-shop-tote-denim-js","55":"component---src-pages-shop-varick-dress-js","56":"component---src-pages-swiper-lazy-js","57":"component---src-pages-vision-js","58":"component---src-templates-collection-collection-js"}[chunkId]||chunkId) + "-" + {"0":"703d4e0024c533456384","1":"b0c5e21ccdfe6a98d8c3","2":"7d4153d260c0197f0043","3":"dd0ac054526a5cc413c8","4":"a5d08a89a215b0aaf242","5":"6172f644b959f9d424e9","6":"1a574c413ce980f6f872","7":"01362020d6eb67a8d649","11":"671b3e9ed89279d1d960","12":"a32511d1d4e91700a286","13":"6ba10c448ae4a49984b3","14":"a4acf899e92f30c312bc","15":"9c96a9a391e9a99791f4","16":"c8b16d143e6e09fc3963","17":"80e3a90893a4bb1658f3","18":"b350d5fff63811441669","19":"6021aa64579c6c482749","20":"10583b87c87242161e55","21":"f7ec7383432a0b31ed34","22":"f73bba8f9329943c96d9","23":"e0d9aefb1ec0451efb4d","24":"3e2e675c274291ae6408","25":"142448bf6342d03af850","26":"9bbb6c353e2df1aabf74","27":"4fe3634587f5407ea905","28":"567b08e79b42f641d0ea","29":"3b115becd5a5b47618e3","30":"98ec3da16f58127e874d","31":"6c8d02de90dd8e188966","32":"8335374e3f6a72c70feb","33":"c62e09bdbad29639f7e4","34":"912666fcf03f9cd5d7f1","35":"d740ee53d2d46d58645a","36":"cd89c5e82cd250ffab0c","37":"e5d0c5e242a54c98d19b","38":"eddc5963e6d5f9500f5e","39":"cc120e72c91023a819aa","40":"fe088a72f084b05b997e","41":"a0d3296bb1e980d41dc3","42":"7ceb82c8991ce19bb9d2","43":"6351a99951e89b7d0762","44":"d968c9824c846b9cf324","45":"9e522ad757991e716f28","46":"9e3d6516c109c07f5a2c","47":"5ab2d09968a6d58a75ff","48":"b5e642f00fa5c53c1f14","49":"9d3ebb8493fc5b8c685b","50":"64b5db28408713f08ed7","51":"fb31aa79a0524d7b8176","52":"14297887a22374a099cb","53":"e7fc10456df42b464ca2","54":"c2f7d32def39c58ec150","55":"99b0fb0c1a5ad4d81a4c","56":"d6eb223f263b99ef9e3d","57":"ce3f7eecc3c59549dd72","58":"b42c0d94648adf3778d2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"a4c92b5b","1":"commons","2":"styles","3":"11100001","4":"3c486bea7d67ad134ab8663d49ccbdc87e5e568a","5":"05b744bfcadbf0a07222ad13dac81db548c3f685","6":"038c46d8fd00ce50b1c747f9b607d00b7f9227fc","7":"c4feed739e63bbbd9e7020453f96b9f103dad3d2","11":"component---src-pages-404-js","12":"component---src-pages-about-js","13":"component---src-pages-contact-js","14":"component---src-pages-explore-js","15":"component---src-pages-index-js","16":"component---src-pages-news-js","17":"component---src-pages-privacy-policy-js","18":"component---src-pages-returns-and-refunds-policy-js","19":"component---src-pages-shipping-policy-js","20":"component---src-pages-shop-airport-band-sweatshirt-js","21":"component---src-pages-shop-alice-dress-js","22":"component---src-pages-shop-alva-windbreaker-js","23":"component---src-pages-shop-bag-js","24":"component---src-pages-shop-baggage-tag-jumpsuit-js","25":"component---src-pages-shop-baggage-tag-keyring-js","26":"component---src-pages-shop-baggage-tag-sweatshirt-1-js","27":"component---src-pages-shop-baggage-tag-sweatshirt-js","28":"component---src-pages-shop-baggage-tag-t-shirt-1-js","29":"component---src-pages-shop-baggage-tag-t-shirt-js","30":"component---src-pages-shop-bedford-hoodie-js","31":"component---src-pages-shop-bedford-sweatpant-js","32":"component---src-pages-shop-blanket-js","33":"component---src-pages-shop-bowery-pant-js","34":"component---src-pages-shop-bustier-dress-js","35":"component---src-pages-shop-carmine-leggings-js","36":"component---src-pages-shop-carmine-short-js","37":"component---src-pages-shop-carmine-top-js","38":"component---src-pages-shop-cart-js","39":"component---src-pages-shop-clinton-windbreaker-js","40":"component---src-pages-shop-cornelia-pant-js","41":"component---src-pages-shop-cornelia-top-js","42":"component---src-pages-shop-index-js","43":"component---src-pages-shop-lawton-sweatpant-js","44":"component---src-pages-shop-lott-dress-js","45":"component---src-pages-shop-oblo-dress-js","46":"component---src-pages-shop-poncho-js","47":"component---src-pages-shop-qr-code-sweatshirt-js","48":"component---src-pages-shop-rainbow-sweatshirt-js","49":"component---src-pages-shop-recycled-cashmere-sweatshirt-1-js","50":"component---src-pages-shop-recycled-cashmere-sweatshirt-js","51":"component---src-pages-shop-skirt-js","52":"component---src-pages-shop-sullivan-dress-js","53":"component---src-pages-shop-top-js","54":"component---src-pages-shop-tote-denim-js","55":"component---src-pages-shop-varick-dress-js","56":"component---src-pages-swiper-lazy-js","57":"component---src-pages-vision-js","58":"component---src-templates-collection-collection-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"515ab731e5271195c4cf","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
